module.exports = __webpack_public_path__ + "img/kuaidi.b9e29d34.png";